import { AppThunkAction } from "..";
import { ProductFeatureTypes, RECEIVE_PRODUCT_FEATURE, REQUEST_PRODUCT_FEATURE } from "./types";
import * as services from "../service";

export const actionCreators = {
    requestProductFeature:
        (forceFullyRefresh: boolean): AppThunkAction<ProductFeatureTypes> =>
        (dispatch, getState) => {
            const appState = getState();
            if (
                appState &&
                appState.productFeatureState &&
                ((!appState.productFeatureState.productFeatureData && !appState.productFeatureState.isLoading) || forceFullyRefresh === true)
            ) {
                services
                    .getProductFeaturesOfBidr()
                    .then((data) => {
                        if (data) {
                            dispatch({ type: RECEIVE_PRODUCT_FEATURE, productFeatureData: data });
                        }
                    })
                    .catch(function (error) {
                        dispatch({ type: RECEIVE_PRODUCT_FEATURE, productFeatureData: undefined });
                    });

                dispatch({ type: REQUEST_PRODUCT_FEATURE });
            }
        },
};
